// extracted by mini-css-extract-plugin
export default {"categories-list":"VKU88B"};